/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Pane, StatusMessage } from "components/ui"
import { Button, StackView } from "@planningcenter/tapestry-react"
import { arrayOf, shape, string, func, array, bool } from "prop-types"
import QuestionQuestion from "./QuestionQuestion"
import QuestionDescription from "./QuestionDescription"
import AttendeeRestrictionSelector from "components/admin/AttendeeRestrictionSelector"

const SectionHeader = ({
  group,
  question,
  attendeeTypes,
  onQuestionChanged,
  onLimitChanged,
  onLimitAttendeeTypeChanged,
  onDescriptionChanged,
  onCancel,
  handleSave,
  handleDelete,
  saveStatus,
  editing
}) => {
  const deprecated = group === "registrant"

  return (
    <div className="d-f@lg">
      <div className="pr-2@lg f-2 mb-4 mb-0@lg">
        <Pane>
          <Pane.Header>
            <Pane.Title>Section Heading</Pane.Title>
          </Pane.Header>
          <Pane.Body>
            <QuestionQuestion
              onQuestionChanged={onQuestionChanged}
              label={"Heading"}
              question={question}
              disabled={deprecated}
            />

            <QuestionDescription
              onDescriptionChanged={onDescriptionChanged}
              question={question}
              disabled={deprecated}
            />
          </Pane.Body>
        </Pane>
      </div>
      <div className="pl-2@lg f-1">
        {group !== "registrant" && (
          <div className="pane">
            <div className="pane__header">
              <label className="pane__title" htmlFor="capacity">
                Options
              </label>
            </div>
            <div className="p-2">
              <div className="label">Available to:</div>
              <AttendeeRestrictionSelector
                attendeeTypes={attendeeTypes.map(at => ({
                  ...at,
                  isAvailable: !!question.visibleToAttendeeTypeIds.includes(at.id)
                }))}
                onCheckboxChange={onLimitAttendeeTypeChanged}
                hasAttendeeRestriction={question.limitQuestions}
                onAttendeeRestrictionChange={onLimitChanged}
              />
            </div>
          </div>
        )}
        <StackView axis="horizontal" distribution="flex-end" spacing={1} marginTop={2}>
          {saveStatus && (
            <div className="mr-a">
              <StatusMessage {...saveStatus} />
            </div>
          )}
          {editing && (
            <Button
              disabled={saveStatus ? true : false}
              theme="destroy"
              onClick={handleDelete}
              title="Delete"
              marginRight="auto"
            />
          )}
          <Button
            disabled={saveStatus ? true : false}
            variant="outline"
            onClick={onCancel}
            title="Cancel"
          />
          {!deprecated && (
            <Button
              disabled={saveStatus ? true : false}
              theme="create"
              onClick={handleSave}
              title="Save"
            />
          )}
        </StackView>
      </div>
    </div>
  )
}

SectionHeader.propTypes = {
  group: string.isRequired,
  question: shape({
    id: string,
    visibleToAttendeeTypeIds: array,
    question: string,
    type: string,
    description: string
  }),
  attendeeTypes: arrayOf(
    shape({
      id: string,
      nameWithRestriction: string
    })
  ),
  onQuestionChanged: func,
  onDescriptionChanged: func,
  onLimitChanged: func,
  onLimitAttendeeTypeChanged: func,
  isSimpleEvent: bool,
  onCancel: func,
  handleDelete: func,
  handleSave: func,
  editing: bool,
  saveStatus: shape({
    text: string,
    icon: string
  })
}

export default SectionHeader
